import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import Hero from './components/Hero';
import ContactForm from './components/ContactForm';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-2xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <p className="text-emerald-600 text-sm font-medium tracking-widest uppercase mb-3">
              Get In Touch
            </p>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
              We'd Love to Hear From You
            </h2>
            <p className="text-gray-600 mt-4 text-base max-w-xl mx-auto">
              Have a question about our plants, landscaping, or wholesale services? Send us a note
              and our team will get back to you shortly.
            </p>
          </div>

          <ContactForm />
        </div>
      </section>

      <Footer />
    </div>
  );
}